var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractEditable from './abstract';
var FullnameEditable = /** @class */ (function (_super) {
    __extends(FullnameEditable, _super);
    function FullnameEditable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FullnameEditable.prototype.render = function () {
        this._element.querySelector('[name="first_name"]').setAttribute('placeholder', this._args.placeholder_first_name);
        this._element.querySelector('[name="last_name"]').setAttribute('placeholder', this._args.placeholder_last_name);
    };
    FullnameEditable.prototype.valueToInput = function (values) {
        if (values.hasOwnProperty('first_name')) {
            this._element.querySelector('[name="first_name"]').value = values.first_name;
        }
        if (values.hasOwnProperty('last_name')) {
            this._element.querySelector('[name="last_name"]').value = values.last_name;
        }
    };
    FullnameEditable.prototype.getValue = function () {
        return {
            'first_name': this._element.querySelector('[name="first_name"]').value,
            'last_name': this._element.querySelector('[name="last_name"]').value,
        };
    };
    FullnameEditable.prototype.getTemplate = function () {
        return "\n\t\t\t<div class=\"aceditable__form__inputs\">\n\t\t\t\t<div class=\"input__group\">\n\t\t\t\t<input name=\"first_name\" type=\"text\" placeholder=\"First name\">\n\t\t\t\t<input name=\"last_name\" type=\"text\" placeholder=\"Last name\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t";
    };
    FullnameEditable.prototype._setDefaults = function () {
        this._defaults.type = 'fullname';
    };
    return FullnameEditable;
}(AbstractEditable));
export default FullnameEditable;
